// extracted by mini-css-extract-plugin
export default {"container":"Music_container__STEJ-","music":"Music_music__qtOBV","heading":"Music_heading__4mrEY","leftTile":"Music_leftTile__SGYjh"};